import React from 'react';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CartPage } from '../../../cart/CartPage';
import { TableLoadingLayout } from '../../../layouts/LoadingLayouts/TableLoadingLayout';
import useShopifyCartSWR from '../../../../hooks/shopify/useShopifyCartSWR';
import storageService, { Locals } from '../../../../utils/storageService';
import { isNullOrUndefined } from '../../../../utils/utils';

export const Cart = () => {
    const { t } = useTranslation('cart', {
        keyPrefix: 'CART',
    });

    const cart_token = storageService.getItem(Locals.CART_TOKEN);
    const { cart, isLoading, isError, forceRefresh, isValidating } =
        useShopifyCartSWR(cart_token);

    return (
        <>
            <PageTitle>{t('TITLE')}</PageTitle>
            <Typography sx={{ paddingY: '20px' }}>{t('CART_NOTE')}</Typography>
            {isError && <Box>{t('LOADING_ERROR')}</Box>}
            {(isLoading || isValidating) && <TableLoadingLayout />}
            {!isLoading && !isValidating && isNullOrUndefined(cart) && (
                <Typography>{t('EMPTY_CART')}</Typography>
            )}
            {!isLoading && !isValidating && !isNullOrUndefined(cart) && (
                <CartPage items={cart} />
            )}
        </>
    );
};
